export default __webpack_public_path__ + "static/media/re3.e3af04d4.png";